import React from 'react';
import { bool, func } from 'prop-types';
import Button from '@mui/material/Button';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import DownloadIcon from '@mui/icons-material/Download';
import Cached from '@mui/icons-material/Cached';
import palette from 'library/theme/figma/palette';

export const ResetButton = ({ onResetView, disabled }) => (
  <Button disabled={disabled} onClick={onResetView} startIcon={<Cached />} variant="dataTable">
    Reset View
  </Button>
);

ResetButton.propTypes = {
  disabled: bool,
  onResetView: func.isRequired,
};

ResetButton.defaultProps = {
  disabled: false,
};

export const FullScreenButton = ({ onFullScreen, isFullScreen, disabled }) => (
  <Button
    disabled={disabled}
    onClick={onFullScreen}
    startIcon={isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
    sx={{
      '& .MuiButton-startIcon': {
        margin: 0,
      },
      minWidth: '32px',
      padding: 0,
    }}
    variant="dataTable"
  />
);

FullScreenButton.propTypes = {
  disabled: bool,
  isFullScreen: bool.isRequired,
  onFullScreen: func.isRequired,
};

FullScreenButton.defaultProps = {
  disabled: false,
};

export const ExportButton = ({ onExportClick, isExporting, disabled }) => (
  <Button
    disabled={disabled}
    onClick={onExportClick}
    size="small"
    startIcon={<DownloadIcon />}
    sx={{
      '&.Mui-disabled': {
        color: palette.light.secondary.dark,
        opacity: 0.26,
      },
    }}
    variant="dataTable"
  >
    {isExporting ? 'Exporting...' : 'Export'}
  </Button>
);

ExportButton.propTypes = {
  disabled: bool,
  isExporting: bool,
  onExportClick: func.isRequired,
};

ExportButton.defaultProps = {
  disabled: false,
  isExporting: false,
};
